import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { ITINERARY_FOOD_INVOICE_PATH } from '../../../../config/paths';
import DeleteItineraryFoodInvoiceButton from './DeleteItineraryFoodInvoiceButton';

const ItineraryFoodInvoiceToolbar = ({ itineraryFoodInvoiceId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton
        path={`${ITINERARY_FOOD_INVOICE_PATH}/${itineraryFoodInvoiceId}/edit`}
      />{' '}
      <DeleteItineraryFoodInvoiceButton
        itineraryFoodInvoiceId={itineraryFoodInvoiceId}
      />
    </div>
  </ButtonToolbar>
);

ItineraryFoodInvoiceToolbar.propTypes = {
  itineraryFoodInvoiceId: PropTypes.number.isRequired,
};

export default ItineraryFoodInvoiceToolbar;
